module.exports = __webpack_public_path__ + "img/logo.6e197da3.png";